import { LoaderPinwheel } from "lucide-react";

const Loading = ({ className }) => {
    return (
        <LoaderPinwheel className={`h-4 w-4 animate-spin ${className}`} />
    );
}

export default Loading;
